import { RobotIcon } from '../Icons/RobotIcon';
import { useAIStore } from './ai-store';
import { useTranslation } from 'react-i18next';

export function AIButton() {
    const { t } = useTranslation();
    const shouldShowAIPanel = useAIStore((state) => state.shouldShowAIPanel);
    const reset = useAIStore((state) => state.reset);
    const setShouldShowAIPanel = useAIStore(
        (state) => state.setShouldShowAIPanel
    );

    return (
        <button
            onClick={() => setShouldShowAIPanel(!shouldShowAIPanel)}
            className="btn btn-primary"
        >
            {t('ai.button')} <RobotIcon fill="white" />
        </button>
    );
}
